export class NLogRuleConfiguration {
    Id: number;
    LoggerCode: string;
    LoggerName: string;
    Enabled: boolean;
  }